
import { useMockedUser } from 'src/hooks/use-mocked-user';
import axios from 'axios';
import useSWR from 'swr';
import { useMemo } from 'react';
import {  getemployeeno } from 'src/auth/context/jwt/utils';
import { fetcher, endpoints } from 'src/utils/axios';
import { HOST_API } from 'src/config-global';

const STORAGE_KEY = 'accessToken';
const accessToken = localStorage.getItem(STORAGE_KEY);
const en = getemployeeno(accessToken);

// ----------------------------------------------------------------------


export function useGetMyCouponbyID(id) {
  const URL = `${endpoints.post.mycouponbyID}?id=${encodeURIComponent(id)}`;
 

  const { data, error, isValidating } = useSWR([URL, {}], fetcher);

  const isLoading = !data && !error;

  const memoizedValue = useMemo(() => {
    const mycouponbyID = data ?? {};
   
    return {
      mycouponbyID,
      mycouponbyIDLoading: isLoading,
      mycouponbyIDError: error,
      mycouponbyIDValidating: isValidating,
      mycouponbyIDEmpty: !isLoading && !mycouponbyID.length,
    };
  }, [data, isLoading, error, isValidating]);

  return memoizedValue;
}

export function useGetApplications() {
  // เพิ่ม en เข้าไปใน URL query string
  const { user } = useMockedUser();
  const URL = `${endpoints.dashboard.list}?en=${encodeURIComponent(user.id)}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(() => {
    // กำหนดค่า applications ให้เป็น data หรือ array ว่างถ้าไม่มี data
    const applications = data ?? [];
    return {
      applications,
      applicationsLoading: isLoading,
      applicationsError: error,
      applicationsValidating: isValidating,
      applicationsEmpty: !isLoading && !applications.length,
    };
  }, [data, isLoading, error, isValidating]); // เพิ่ม en ใน dependencies

  return memoizedValue;
}

export function useGetPosts() {
  const URL = endpoints.post.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(() => {
    // กำหนดค่า posts ให้เป็น data หรือ array ว่างถ้าไม่มี data
    const posts = data ?? [];
    return {
      posts,
      postsLoading: isLoading,
      postsError: error,
      postsValidating: isValidating,
      postsEmpty: !isLoading && !posts.length,
    };
  }, [data, isLoading, error, isValidating]); // แก้ไข dependencies ให้เหมาะสม

  return memoizedValue;
}

export const saveCoupons = async (couponData) => {
  const URL = `${HOST_API}${endpoints.post.Save}`;
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  try {
    const response = await axios.post(URL, couponData, config);
    return response.data; // Assuming response is the successfully saved data
  } catch (error) {
    console.error("Error in saveCoupons:", error);
    throw error; // It's a good practice to handle this error in the calling component
  }
};
export const changeImage = async (imageBlob) => {
  const URL = `${HOST_API}${endpoints.user.changeimage}`;

  // ดึง token จาก localStorage
 
  const token = localStorage.getItem('accessToken');
  // ตรวจสอบว่ามีการตั้งค่า token หรือไม่
  if (!token) {
    console.error('Token is missing or not set correctly');
    throw new Error('Authentication token is missing');
  }

  // สร้าง FormData และแนบ Blob เป็นไฟล์รูปภาพ
  const formData = new FormData();
  const file = new File([imageBlob], 'image.png', { type: 'image/png' }); // แปลง Blob เป็นไฟล์
  formData.append('file', file);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`, // แนบ token ไปใน header
    },
  };

  try {
    const response = await axios.post(URL, formData, config);
    return response.data;
  } catch (error) {
    // ตรวจสอบสถานะข้อผิดพลาด หากเป็น 401 ให้แจ้งเตือนว่าการยืนยันตัวตนล้มเหลว
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized: Token may be expired or invalid');
    }
    console.error("Error in changeImage:", error);
    throw error;
  }
};

export const saveRegister = async (data) => {

  const URL = `${HOST_API}${endpoints.auth.register}`;

  try {
    const response = await axios.post(URL, data);
    return response.data; // Assuming response is the successfully saved data
  } catch (error) {
    console.error("Error in Save Register:", error);
    throw error; // It's a good practice to handle this error in the calling component
  }
};

export const usingCoupon = async (couponData) => {
  const URL = `${HOST_API}${endpoints.post.UsingCoupon}`;
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  try {
    const response = await axios.post(URL, couponData, config);
    return response.data; // Assuming response is the successfully saved data
  } catch (error) {
    console.error("Error in using Coupons:", error);
    throw error; // It's a good practice to handle this error in the calling component
  }
};
export const markasUseCoupon = async (couponData) => {
  const URL = `${HOST_API}${endpoints.post.MarkasUse}`;
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  try {
    const response = await axios.post(URL, couponData, config);
    return response.data; // Assuming response is the successfully saved data
  } catch (error) {
    console.error("Error in saveCoupons:", error);
    throw error; // It's a good practice to handle this error in the calling component
  }
};

export const Redirect = async (idapp) => {
  const URL = `${HOST_API}${endpoints.dashboard.Next}`;
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
  const data = {
    id: idapp,
    empNo: en
  };
  
  try {
    const response = await axios.post(URL, data, config);
    const { endpointUrl, tokenURL } = response.data;

    // สร้างฟอร์มแบบ dynamic
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = endpointUrl;
    form.target = '_self'; // ใช้ `_self` เพื่อเปิดในหน้าต่างเดียวกัน

    // สร้าง input element สำหรับ token
    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'token';
    tokenInput.value = tokenURL;

    // เพิ่ม input element เข้าไปในฟอร์ม
    form.appendChild(tokenInput);

    // เพิ่มฟอร์มเข้าไปใน body
    document.body.appendChild(form);

    // ทำการ submit ฟอร์ม
    form.submit();

    return response.data;
  } catch (error) {
    console.error("Error in Redirect:", error);
    throw error;
  }
};



export function useGetMyCoupon() {
  const URL = endpoints.post.mycoupon;
  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(() => {
    // กำหนดค่า posts ให้เป็น data หรือ array ว่างถ้าไม่มี data
    const coupons = data ?? [];
    return {
      coupons,
      couponsLoading: isLoading,
      couponsError: error,
      couponsValidating: isValidating,
      couponsEmpty: !isLoading && !coupons.length,
    };
  }, [data, isLoading, error, isValidating]); // แก้ไข dependencies ให้เหมาะสม

  return memoizedValue;
}





